<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

const props = defineProps({
  voiceAgentId: {
    type: [String, Number],
    default: 'all',
  },
});

const emit = defineEmits(['update']);

const voiceAgents = useMapGetter('voiceAgents/getRecords');

const voiceAgentOptions = computed(() => {
  const options = [{ value: 'all', label: 'All Voice Agents' }];

  if (voiceAgents.value) {
    voiceAgents.value.forEach(agent => {
      options.push({
        value: agent.id,
        label: agent.name,
      });
    });
  }

  return options;
});

const handleUpdate = value => {
  emit('update', value);
};
</script>

<template>
  <div class="flex items-center gap-2">
    <label class="text-sm font-medium text-n-slate-12">
      {{ $t('AI_VOICE.ACTIONS.FILTER_BY_AGENT') }}:
    </label>
    <ComboBox
      :model-value="voiceAgentId"
      :options="voiceAgentOptions"
      class="w-64"
      @update:model-value="handleUpdate"
    />
  </div>
</template>
